import { render, staticRenderFns } from "./myCollect.vue?vue&type=template&id=26a7275b&scoped=true&"
import script from "./myCollect.vue?vue&type=script&lang=js&"
export * from "./myCollect.vue?vue&type=script&lang=js&"
import style0 from "./myCollect.vue?vue&type=style&index=0&id=26a7275b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a7275b",
  null
  
)

export default component.exports